import { Subject, takeUntil } from 'rxjs';
import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';

import { ProductClassEnum } from '@sifca-monorepo/ecommerce-generator';
import { InternalProductType } from '@sifca-monorepo/ecommerce-generator';

import { AppService } from '../../services';

@Component({
  template: '',
})
export class BaseBaguetteProductGroupComponent implements OnInit, OnDestroy {
  protected unsubscribeAll: Subject<any> = new Subject<any>();

  products: InternalProductType[];

  constructor(protected appService: AppService, protected changeDetectorRef: ChangeDetectorRef) {
    this.appService.getInternalProductsByClass(ProductClassEnum.BEST_SELLERS).subscribe();
  }

  ngOnInit(): void {
    this.appService.productsByClass$.pipe(takeUntil(this.unsubscribeAll)).subscribe((products) => {
      this.products = products;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }
}
